var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24989 12.1382C7.24989 11.7282 7.58989 11.3882 7.99989 11.3882H10.9999V7.63818C10.9999 7.08818 10.5499 6.63818 9.99989 6.63818H7.76989C4.61989 6.63818 1.87989 9.21818 1.99989 12.3582C2.05989 13.7882 2.65989 15.0782 3.60989 16.0282C4.60989 17.0182 5.97989 17.6382 7.49989 17.6382H9.99989C10.5499 17.6382 10.9999 17.1882 10.9999 16.6382V12.8882H7.99989C7.58989 12.8882 7.24989 12.5482 7.24989 12.1382Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.39 8.24818C19.39 7.25818 18.02 6.63818 16.5 6.63818H14C13.45 6.63818 13 7.08818 13 7.63818V11.3882H16C16.41 11.3882 16.75 11.7282 16.75 12.1382C16.75 12.5482 16.41 12.8882 16 12.8882H13V16.6382C13 17.1882 13.45 17.6382 14 17.6382H16.23C19.38 17.6382 22.12 15.0582 21.99 11.9182C21.94 10.4882 21.33 9.19818 20.39 8.24818Z",
    fill: "#464650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.3882H11V12.8882H13V11.3882Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.81c0a57ccb50871444eab84ccf09f3e7.svg";
export { ForwardRef as ReactComponent };